// "O jogo": a Maré animada, as seis mecânicas e capturas do jogo.
import { useTranslation } from "@ecliptica/i18n";
import { Panel, Section } from "./Section";

const MECHANICS = ["tide", "apogee", "lanes", "seals", "echoes", "ritual"] as const;
const SHOTS = [
  { src: "/shots/batalha.webp", key: "battle", big: true },
  { src: "/shots/colecao.webp", key: "collection" },
  { src: "/shots/saquetas.webp", key: "packs" },
] as const;

/** Barra da Maré Celeste: Lua (−4) … centro … Sol (+4), a pulsar. */
function TideBar() {
  const cells = Array.from({ length: 9 }, (_, i) => i - 4);
  return (
    <div aria-hidden className="mx-auto mb-9 flex items-center justify-center gap-1.5">
      <span className="text-[26px] text-lua">☾</span>
      {cells.map((v) => (
        <i
          key={v}
          className="h-3 w-[6vw] max-w-[34px] animate-[tide_6s_ease-in-out_infinite] rounded-[3px]"
          style={{
            background: v === 0 ? "var(--ec-eclipse)" : v < 0 ? "#38407a" : "#6b4a20",
            animationDelay: `${(4 - Math.abs(v)) * 0.2}s`,
          }}
        />
      ))}
      <span className="text-[26px] text-sol">☀</span>
    </div>
  );
}

export function PlaySection() {
  const { t } = useTranslation();
  return (
    <Section id="game" title={t("play.title")} lead={t("play.lead")}>
      <TideBar />
      <div className="mx-auto grid max-w-[1200px] gap-4.5 sm:grid-cols-[repeat(auto-fit,minmax(280px,1fr))]">
        {MECHANICS.map((m) => (
          <Panel key={m} className="p-5.5">
            <h3 className="mb-1.5 text-xl font-extrabold">{t(`mech.${m}.t`)}</h3>
            <p className="text-moon">{t(`mech.${m}.d`)}</p>
          </Panel>
        ))}
      </div>
      <div className="mx-auto mt-10 grid max-w-[1200px] gap-3.5 md:grid-cols-[2fr_1fr] md:grid-rows-2">
        {SHOTS.map((s) => (
          <figure key={s.key} className={`m-0 overflow-hidden rounded-xl border bg-card ${"big" in s ? "md:row-span-2" : ""}`}>
            <img
              src={s.src}
              srcSet={`${s.src.replace(".webp", "-800.webp")} 800w, ${s.src} 1600w`}
              sizes={"big" in s ? "(min-width: 768px) 66vw, 100vw" : "(min-width: 768px) 33vw, 100vw"}
              alt={t(`play.shots.${s.key}`)}
              loading="lazy"
              decoding="async"
              width={1600}
              height={856}
              className="h-full w-full object-cover"
            />
            <figcaption className="px-3 py-2 text-sm text-muted-foreground">{t(`play.shots.${s.key}`)}</figcaption>
          </figure>
        ))}
      </div>
      <p className="mt-7 text-center text-gold">{t("play.modes")}</p>
    </Section>
  );
}
